import {
  Channel,
  ROOT,
  SURVEY_URLS,
  SURVEY_MENU_VISIBLE,
  Topic
} from "../../constants";
import { MessageBrokerUtils, UrlUtils } from "../../utils";
import React, { useCallback, useEffect, useMemo } from "react";
import { UISelectors, UserContextSelectors } from "../../redux/selectors";
import { useDispatch, useSelector } from "react-redux";
import { Brand } from "../../configurations";
import { FormattedMessage } from "react-intl";
import { Item } from "../../components/Menu";
import { LocalizationMessages } from "../../localization/messages";
import { MenuActionCreators } from "../../redux/action-creators";
import { SelectableMenuItem } from "../../components/Menu";

const getResources = brandId => {
  const surveyResources = {
    surveyText: LocalizationMessages.survey,
    menuItemTag: LocalizationMessages.menuItemTag,
    surveyIcon: "up-for-8"
  };

  switch (brandId) {
    case Brand.Sport_ES: {
      surveyResources.menuItemTag = LocalizationMessages.menuItemTagES;
      surveyResources.surveyText = LocalizationMessages.surveyES;
      break;
    }
    case Brand.Sport_RO: {
      surveyResources.surveyText = LocalizationMessages.surveyRO;
      break;
    }
    case Brand.Sport_IT: {
      surveyResources.surveyText = LocalizationMessages.surveyIT;
      break;
    }
    case Brand.Sport_DK: {
      surveyResources.surveyText = LocalizationMessages.surveyDK;
      break;
    }
    case Brand.Sport_MG_DK: {
      surveyResources.surveyText = LocalizationMessages.surveyDKMRG;
      break;
    }
    case Brand.Sport_CA: {
      surveyResources.menuItemTag = LocalizationMessages.menuItemTag;
      surveyResources.surveyIcon = "perfect-10";
      break;
    }
    case Brand.Sport_CO:
    case Brand.Sport_VA:
    case Brand.Sport_IN:
    case Brand.Sport_MI: {
      surveyResources.surveyIcon = "perfect-10";
      break;
    }
  }

  return surveyResources;
};

export const SurveyMenuItem = props => {
  const links = useSelector(UISelectors.links);
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const isPromotionRestricted = useSelector(
    UserContextSelectors.isPromotionRestricted
  );
  const brandId = useSelector(UserContextSelectors.brandId);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const dispatch = useDispatch();
  const { surveyText, menuItemTag, surveyIcon } = useMemo(
    () => getResources(brandId),
    [brandId]
  );

  const item = useMemo(
    () =>
      new Item({
        URL: UrlUtils.getSEOUrl(links.survey),
        title: surveyText,
        iconKey: surveyIcon
      }),
    [links.survey, surveyText, surveyIcon]
  );

  const selectSurveyItem = useCallback(
    url => {
      const { pathname, hash } = url || {};
      if (
        SURVEY_URLS?.some(surveyUrl => {
          const { pathname: surveyPathName, hash: surveyHash } = new URL(
            surveyUrl,
            window.location.origin
          );

          const pathWithoutLang = UrlUtils.getURLWithoutLang(pathname);

          return (
            (pathWithoutLang &&
              pathWithoutLang !== ROOT &&
              pathWithoutLang === surveyPathName) ||
            (hash && hash === surveyHash)
          );
        })
      ) {
        dispatch(MenuActionCreators.select(item));
      }
    },
    [dispatch, item]
  );

  useEffect(() => {
    selectSurveyItem(window.location);
  }, [selectSurveyItem, isMobile]);

  useEffect(() => {
    let subscription = MessageBrokerUtils.subscribe({
      channel: Channel.ROUTER,
      topic: Topic.Navigate,
      callback: url => {
        selectSurveyItem(new URL(url, window.location.origin));
      }
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, [selectSurveyItem]);

  const onClick = () => {
    if (isMobile) {
      dispatch(MenuActionCreators.hideHamburgerMenu());
    }
  };

  const isSurveyVisible = useMemo(() => {
    if (SURVEY_MENU_VISIBLE) {
      return brandId === Brand.Sport_ES
        ? !isPromotionRestricted && isAuthenticated
        : true;
    }

    return false;
  }, [brandId, isAuthenticated, isPromotionRestricted]);

  return (
    isSurveyVisible && (
      <SelectableMenuItem
        {...props}
        onClick={onClick}
        item={item}
        automationId="uc-survey"
        tag={
          <span className="tag">
            <FormattedMessage {...menuItemTag} />
          </span>
        }
      />
    )
  );
};
